import styled from '@emotion/styled'
import { breakpointMax, calcRem, fonts } from '../../__styling'

export const StyledStaticHeroContainer = styled('div')({
    display: 'flex',
    marginTop: calcRem(12),
    marginBottom: calcRem(24),
    [breakpointMax('sm')]: {
        flexDirection: 'column-reverse',
    },
})
export const StyledStaticTextWrap = styled('div')({
    flexBasis: '45%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `0 2.5%`,
    [breakpointMax('sm')]: {
        flexBasis: '100%',
        marginTop: calcRem(10),
    },
})
export const StyledStaticTextWrapTop = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    [breakpointMax('sm')]: {
        width: '60%',
    },
    [breakpointMax('xs')]: {
        width: '80%',
    },
    [breakpointMax('xxs')]: {
        width: '100%',
    },
})
export const StyledStaticDescription = styled('p')({
    fontFamily: fonts.sevennews.headingAlternative,
    fontSize: calcRem(18),
    lineHeight: calcRem(22),
    fontWeight: 300,
    textAlign: 'left',
})

export const StyledStaticTextWrapInfo = styled('div')({
    flexBasis: '45%',
    border: 'solid 3px blue',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
})

export const StyledStaticLogo = styled('img')({
    width: calcRem(270),
})

export const StyledStaticTitle = styled('h2')(({ theme }) => ({
    fontSize: calcRem(36),
    fontWeight: 700,
    fontFamily: fonts.sevennews.headingAlternative,
    marginTop: 0,
    marginBottom: calcRem(16),
}))

export const StyledStaticMediaWrap = styled('div')({
    flexBasis: '55%',
    [breakpointMax('sm')]: {
        flexBasis: '100%',
    },
})
export const StyledStaticMediaImage = styled('img')({
    width: '100%',
})
